import React, { useEffect, useState, useRef } from "react";
import { Route, Switch, Redirect } from "react-router";
import { useDispatch } from "react-redux";

import * as R from "ramda";

import { useLocation, useHistory } from "react-router-dom";
import { AidavieMain } from "./main";
import { LoadingState } from "../../_common/loadingState";

import { fetchAidavieFiles } from "../../actions/backoffice/aidavie";
import * as Loadings from "../../constants/loadings/backoffice/aidavie";
import { fetchAllPartners, fetchUsersByRole } from "../../actions/backoffice/dossiers";
import { GetPartners, GetPartnersDefaultState } from "../../actions/backoffice/partners";

export const Aidavie = ({ partner, aidavieState, user, isPartner, partnersState }) => {
	const dispatch = useDispatch();
	const searchQuery = useLocation();
	const pageQuery = new URLSearchParams(window.location.search);
	const history = useHistory();

	const [teleconseillers, setTeleconseillers] = useState([]);

	let page = pageQuery.get("page");
	let search = pageQuery.get("search");
	let sortBy = pageQuery.get("sortBy");
	let sortDesc = pageQuery.get("sortDesc");
	let operatorId = pageQuery.get("operatorId");
	let fromCreationDate = pageQuery.get("fromCreationDate");
	let toCreationDate = pageQuery.get("toCreationDate");

	page = R.isNil(page) ? 1 : parseInt(page);
	search = R.isNil(search) ? "" : search;
	sortBy = R.isNil(sortBy) ? "CreationDate" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "true" : sortDesc;
	operatorId = R.isNil(operatorId) ? "00000000-0000-0000-0000-000000000000" : operatorId;

	const [pageSearch, setPageSearch] = useState(search);

	const routerQuery = {
		page,
		search,
		sortBy,
		sortDesc,
		operatorId,
		fromCreationDate,
		toCreationDate,
	};

	useEffect(() => {
		if (isNaN(page) || page === 0) {
			return;
		}

		const query = new URLSearchParams(window.location.search);
		const queryOperatorId = query.get("operatorId");
		if (window.location.search == "" && R.isNil(queryOperatorId)) {
			return;
		}
		const queryFromCreationDate = pageQuery.get("fromCreationDate");
		const queryToCreationDate = pageQuery.get("toCreationDate");

		dispatch(fetchAidavieFiles(page, search, sortBy, sortDesc, R.isNil(queryOperatorId) ? "" : queryOperatorId, R.isNil(queryFromCreationDate) ? "" : queryFromCreationDate, R.isNil(queryToCreationDate) ? "" : queryToCreationDate));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [window.location.search]);

	useEffect(() => {
		if (isNaN(page) || page === 0) {
			history.push("/backoffice/aidavie");
			return;
		}

		dispatch(GetPartnersDefaultState());

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchQuery.search, history.location]);

	if (aidavieState.isLoading.includes(Loadings.FETCHING_AIDAVIE_FILES) && R.isNil(aidavieState.items)) {
		return <LoadingState />;
	}

	if (R.isNil(aidavieState.items)) {
		return "";
	}
	return (
		<Switch>
			<Route exact path="/backoffice/aidavie">
				<AidavieMain aidavieState={aidavieState} partners={partnersState?.partners} pageSearch={pageSearch} setPageSearch={setPageSearch} partnerState={partner} routerQuery={routerQuery} operatorId={operatorId} pageQuery={pageQuery} teleconseillers={teleconseillers} isPartner={isPartner} userId={user?.id} />
			</Route>
			<Route
				render={() => {
					return <Redirect exact to="/backoffice/aidavie" />;
				}}
			/>
		</Switch>
	);
};
